"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Stepper_style_1 = require("./Stepper.style");
var StepConnector_1 = require("./StepConnector");
var StepIcon_1 = require("./StepIcon");
exports.Stepper = function (_a) {
    var activeStep = _a.activeStep, steps = _a.steps, completed = _a.completed, handleStep = _a.handleStep, _b = _a.nonLinear, nonLinear = _b === void 0 ? false : _b;
    var classes = Stepper_style_1.useStepperStyles();
    return (react_1.default.createElement(core_1.Stepper, { "data-signa": "stepper", nonLinear: nonLinear, activeStep: activeStep, connector: react_1.default.createElement(StepConnector_1.StepConnector, null) }, steps.map(function (label, index) { return (react_1.default.createElement(core_1.Step, { classes: { root: classes.step }, key: label },
        react_1.default.createElement(core_1.StepButton, { classes: { root: classes.stepButton }, "data-signa": "stepper-button-" + index, onClick: function () { return handleStep(index); }, completed: completed[index] },
            react_1.default.createElement(core_1.StepLabel, { classes: {
                    label: classes.label,
                    iconContainer: classes.iconContainer,
                    active: classes.active,
                    completed: classes.completed,
                }, StepIconComponent: StepIcon_1.StepIcon }, label)))); })));
};
